import { generateRecentTimestamp } from "utils/timestamp";
const notifications = {
  notifications: {
    events: {
      totalCOunt: 5,
      eventsList: [
        {
          incident: "Speed Violation",
          busNo: "1010",
          route: "Route#1",
          source: {
            locality: "Intercontinental abu dhabi by IHG",
            coOrdinates: { lat: 24.45712, lng: 54.32851 },
          },
          destination: {
            locality: "Jarneen Street",
            coOrdinates: { lat: 24.438668, lng: 54.370515 },
          },
          currentLocation: {
            locality: "Corniche Road",
            coOrdinates: { lat: 24.45712, lng: 54.32851 },
          },
          nextStop: {
            locality: "Marina Mall",
            coOrdinates: { lat: 24.476, lng: 54.321 },
          },
          driver: "Ahmed Khan",
          licenceNo: "DRV#100101",
          timeStamp: generateRecentTimestamp(),
        },
        {
          incident: "Harsh Braking",
          busNo: "1020",
          route: "Route#2",
          source: {
            locality: "Suzuki Showroom",
            coOrdinates: { lat: 24.43451, lng: 54.41272 },
          },
          destination: {
            locality: "Mushrif Mall",
            coOrdinates: { lat: 24.476467, lng: 54.365783 },
          },
          currentLocation: {
            locality: "Hamdan Street",
            // coOrdinates: { lat: 24.486, lng: 54.361 },
            coOrdinates: { lat: 24.43451, lng: 54.41272 },
          },
          nextStop: {
            locality: "Tourist Club Area",
            coOrdinates: { lat: 24.495, lng: 54.382 },
          },
          driver: "Mohammed Ali",
          licenceNo: "DRV#100102",
          timeStamp: generateRecentTimestamp(),
        },
        {
          incident: "Sharp Turn",
          busNo: "1030",
          route: "Route#3",
          source: {
            locality: "Al Zahiyah",
            coOrdinates: { lat: 24.37313, lng: 54.53794 },
          },
          destination: {
            locality: "Saadiyat Island",
            coOrdinates: { lat: 24.532, lng: 54.436 },
          },
          currentLocation: {
            locality: "Mina Zayed Port",
            // coOrdinates: { lat: 24.512, lng: 54.385 },
            coOrdinates: { lat: 24.37313, lng: 54.53794 },
          },
          nextStop: {
            locality: "Louvre Abu Dhabi",
            coOrdinates: { lat: 24.533, lng: 54.397 },
          },
          driver: "Fatima Noor",
          licenceNo: "DRV#100103",
          timeStamp: generateRecentTimestamp(),
        },
        {
          incident: "Signal Loss",
          busNo: "1040",
          route: "Route#4",
          source: {
            locality: "Sas Al Nakhl",
            coOrdinates: { lat: 24.40496, lng: 54.52664 },
          },
          destination: {
            locality: "Umm Yifeenah",
            coOrdinates: { lat: 24.47324, lng: 54.45434 },
          },
          currentLocation: {
            locality: "Gate Towers",
            // coOrdinates: { lat: 24.499, lng: 54.414 },
            coOrdinates: { lat: 24.40496, lng: 54.52664 },
          },
          nextStop: {
            locality: "Repton School",
            coOrdinates: { lat: 24.47324, lng: 54.45434 },
          },
          driver: "Khalid Hassan",
          licenceNo: "DRV#100104",
          timeStamp: generateRecentTimestamp(),
        },
        {
          incident: "Route Deviation",
          busNo: "1050",
          route: "Route#5",
          source: {
            locality: "Al Maryah Island",
            coOrdinates: { lat: 24.493, lng: 54.384 },
          },
          destination: {
            locality: "Cleveland Clinic",
            coOrdinates: { lat: 24.47324, lng: 54.45434 },
          },
          currentLocation: {
            locality: "The Galleria Mall",
            // coOrdinates: { lat: 24.497, lng: 54.388 },
            coOrdinates: { lat: 24.493, lng: 54.384 },
          },
          nextStop: {
            locality: "Rosewood Hotel",
            coOrdinates: { lat: 24.498, lng: 54.386 },
          },
          driver: "Aisha Rahman",
          licenceNo: "DRV#100105",
          timeStamp: generateRecentTimestamp(),
        },
      ],
    },
    incidents: {
      totalCOunt: 5,
      incidentsList: [
        {
          incident: "Harsh Braking",
          busNo: "2001",
          route: "Route#1",
          source: {
            locality: "Abu Dhabi Mall",
            coOrdinates: { lat: 24.44845, lng: 54.60787 }
          },
          destination: {
            locality: "Corniche Beach",
            coOrdinates: { lat: 24.494889, lng: 54.383899 }
          },
          currentLocation: {
            locality: "Al Zahiyah",
            coOrdinates: { lat: 24.44845, lng: 54.60787 }
            // coOrdinates: { lat: 24.495492, lng: 54.385674 }
          },
          nextStop: {
            locality: "Al Mina",
            coOrdinates: { lat: 24.492378, lng: 54.370190 }
          },
          driver: "John Doe",
          licenceNo: "DRV#2001",
          timeStamp: generateRecentTimestamp(),
        },
        {
          incident: "Sudden Stop",
          busNo: "2002",
          route: "Route#2",
          source: {
            locality: "AL Jubail isaland",
            coOrdinates: { lat: 24.513453, lng: 54.495894 }
          },
          destination: {
            locality: "Reem Island",
            coOrdinates: { lat: 24.493839, lng: 54.409442 }
          },
          currentLocation: {
            locality: "Cleveland Clinic Abu Dhabi",
            coOrdinates: { lat: 24.513453, lng: 54.495894 }
            // coOrdinates: { lat: 24.502158, lng: 54.385891 }
          },
          nextStop: {
            locality: "Shams Abu Dhabi",
            coOrdinates: { lat: 24.494013, lng: 54.410712 }
          },
          driver: "Alice Smith",
          licenceNo: "DRV#2002",
          timeStamp: generateRecentTimestamp(),
        },
        {
          incident: "Hard Cornering",
          busNo: "2003",
          route: "Route#3",
          source: {
            locality: "Zayed Sports City",
            coOrdinates: { lat: 24.420204, lng: 54.454320 }
          },
          destination: {
            locality: "Mushrif Mall",
            coOrdinates: { lat: 24.445893, lng: 54.434506 }
          },
          currentLocation: {
            locality: "Al Maqtaa",
            coOrdinates: { lat: 24.420204, lng: 54.454320 }
            // coOrdinates: { lat: 24.426112, lng: 54.455821 }
          },
          nextStop: {
            locality: "Al Mushrif",
            coOrdinates: { lat: 24.449201, lng: 54.428442 }
          },
          driver: "Carlos Rivera",
          licenceNo: "DRV#2003",
          timeStamp: generateRecentTimestamp(),
        },
        {
          incident: "Obstacle Avoidance",
          busNo: "2004",
          route: "Route#4",
          source: {
            locality: "Sheikh Zayed Grand Mosque",
            coOrdinates: { lat: 24.412778, lng: 54.474917 }
          },
          destination: {
            locality: "Khalifa Park",
            coOrdinates: { lat: 24.428358, lng: 54.460006 }
          },
          currentLocation: {
            locality: "Al Maqtaa Bridge",
            coOrdinates: { lat: 24.412778, lng: 54.474917 }
            // coOrdinates: { lat: 24.415699, lng: 54.471111 }
          },
          nextStop: {
            locality: "Al Bateen",
            coOrdinates: { lat: 24.462701, lng: 54.343971 }
          },
          driver: "Maria Lopez",
          licenceNo: "DRV#2004",
          timeStamp: generateRecentTimestamp(),
        },
        {
          incident: "Pedestrian Alert",
          busNo: "2005",
          route: "Route#5",
          source: {
            locality: "Marina Mall",
            coOrdinates: { lat: 24.466420, lng: 54.321213 }
          },
          destination: {
            locality: "Nation Towers",
            coOrdinates: { lat: 24.466273, lng: 54.345617 }
          },
          currentLocation: {
            locality: "Breakwater",
            coOrdinates: { lat: 24.466420, lng: 54.321213 }
            // coOrdinates: { lat: 24.467841, lng: 54.316422 }
          },
          nextStop: {
            locality: "Corniche",
            coOrdinates: { lat: 24.474870, lng: 54.344819 }
          },
          driver: "Ana Martinez",
          licenceNo: "DRV#2005",
          timeStamp: generateRecentTimestamp(),
        },
      ],
    },
    oprAlerts: {
      totalCOunt: 5,
      oprAlertsList: [
        {
          incident: "Sharp Turn",
          busNo: "1020",
          route: "Route#11",
          source: {
            locality: "Al Danah",
            coOrdinates: { lat: 24.4922, lng: 54.3705 }
          },
          destination: {
            locality: "Al Bateen",
            coOrdinates: { lat: 24.4699, lng: 54.3231 }
          },
          currentLocation: {
            locality: "Al Khalidiyah",
            coOrdinates: { lat: 24.4922, lng: 54.3705 }
            // coOrdinates: { lat: 24.4711, lng: 54.3552 }
          },
          nextStop: {
            locality: "Marina Mall",
            coOrdinates: { lat: 24.4601, lng: 54.3191 }
          },
          driver: "Omar Ali",
          licenceNo: "DRV#445566",
          timeStamp: generateRecentTimestamp()
        },
        {
          incident: "Route Deviation",
          busNo: "1035",
          route: "Route#12",
          source: {
            locality: "zayed hight organiztion",
            coOrdinates: { lat: 24.322268, lng: 54.609425 }
          },
          destination: {
            locality: "Corniche Beach",
            coOrdinates: { lat: 24.4820, lng: 54.3350 }
          },
          currentLocation: {
            locality: "Hamdan Street",
            coOrdinates: { lat: 24.322268, lng: 54.609425 }
            // coOrdinates: { lat: 24.4851, lng: 54.3668 }
          },
          nextStop: {
            locality: "Al Hosn",
            coOrdinates: { lat: 24.4812, lng: 54.3575 }
          },
          driver: "Fatima Khan",
          licenceNo: "DRV#778899",
          timeStamp: generateRecentTimestamp()
        },
        {
          incident: "Engine Idle",
          busNo: "1101",
          route: "Route#13",
          source: {
            locality: "Rahayl Cars City",
            coOrdinates: { lat: 24.268395, lng: 54.486533 }
          },
          destination: {
            locality: "Khalifa Park",
            coOrdinates: { lat: 24.4280, lng: 54.4715 }
          },
          currentLocation: {
            locality: "Airport Road",
            coOrdinates: { llat: 24.268395, lng: 54.486533 }
            // coOrdinates: { lat: 24.4400, lng: 54.3895 }
          },
          nextStop: {
            locality: "Sheikh Zayed Mosque",
            coOrdinates: { lat: 24.4122, lng: 54.4749 }
          },
          driver: "Mohammed Al Mansoori",
          licenceNo: "DRV#332211",
          timeStamp: generateRecentTimestamp()
        },
        {
          incident: "Signal Loss",
          busNo: "1150",
          route: "Route#14",
          source: {
            locality: "Yas Gateway Park",
            coOrdinates: { lat: 24.487466, lng: 54.624203 }
          },
          destination: {
            locality: "Saadiyat Island",
            coOrdinates: { lat: 24.5335, lng: 54.4231 }
          },
          currentLocation: {
            locality: "Zayed Port",
            coOrdinates: { lat: 24.487466, lng: 54.624203 }
            // coOrdinates: { lat: 24.5180, lng: 54.4050 }
          },
          nextStop: {
            locality: "Louvre Museum",
            coOrdinates: { lat: 24.5330, lng: 54.3971 }
          },
          driver: "Aisha Rahman",
          licenceNo: "DRV#556677",
          timeStamp: generateRecentTimestamp()
        },
        {
          incident: "Geofence Exit",
          busNo: "1202",
          route: "Route#15",
          source: {
            locality: "Mussafah",
            coOrdinates: { lat: 24.3580, lng: 54.4825 }
          },
          destination: {
            locality: "Mohammed Bin Zayed City",
            coOrdinates: { lat: 24.3360, lng: 54.5462 }
          },
          currentLocation: {
            locality: "Shakhbout City",
            coOrdinates: { lat: 24.3580, lng: 54.4825 }
            // coOrdinates: { lat: 24.3700, lng: 54.5670 }
          },
          nextStop: {
            locality: "Khalifa City",
            coOrdinates: { lat: 24.4251, lng: 54.6052 }
          },
          driver: "Rashid Saeed",
          licenceNo: "DRV#101010",
          timeStamp: generateRecentTimestamp()
        },
      ],
    },
  },
};
export default notifications;